import React from 'react';
import {Typography} from '~library/atoms/Typography';
import {Button} from '~library/atoms/Button';
import {ReflectVerticalIcon} from '~library/svg/ReflectVerticalIcon';
import {ReflectHorizontalIcon} from '~library/svg/ReflectHorizontalIcon';
import {useImageFlip} from '~/CreateFabricInvitation/components/PhotoEditor/common/useImageFlip';

export const FlipControls = ({canvas}) => {
  const {handleFlipX, handleFlipY} = useImageFlip(canvas);

  return (
    <div className="uyo-control-flip-buttons">
      <div className="uyo-control-flip-button-container">
        <Button
          variant="secondary"
          size="large"
          onClick={handleFlipX}
          className="uyo-control-flip-button"
          data-qa-id="flip-horizontal-btn"
        >
          <div className="uyo-control-flip-icon">
            <ReflectHorizontalIcon />
          </div>
          <Typography variant="paragraph3">Flip Horizontal</Typography>
        </Button>
      </div>
      <div className="uyo-control-flip-button-container">
        <Button
          variant="secondary"
          size="large"
          onClick={handleFlipY}
          className="uyo-control-flip-button"
          data-qa-id="flip-vertical-btn"
        >
          <div className="uyo-control-flip-icon">
            <ReflectVerticalIcon />
          </div>
          <Typography variant="paragraph3">Flip Vertical</Typography>
        </Button>
      </div>
    </div>
  );
};
